import { defineComponent as _defineComponent } from 'vue';
import AzIcon from '~/components/_next/atoms/AzIcon.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'AzCheckbox',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    inputName: null,
    disabled: {
      type: Boolean
    },
    checkboxPosition: {
      default: 'left'
    },
    errors: {
      default: function _default() {
        return [];
      }
    }
  },
  emits: ['input'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var inputPosition = computed(function () {
      return props.checkboxPosition === 'right' ? 'row' : 'row-reverse';
    });
    return {
      __sfc: true,
      props: props,
      emit: emit,
      inputPosition: inputPosition,
      AzIcon: AzIcon
    };
  }
});